import React from "react";

import { AuthorizationADFS } from "../providers/AuthorizationADFS";
import { AuthorizationBase } from "../providers/AuthorizationBase";
import { AuthorizationMSAL } from "../providers/AuthorizationMSAL";

const createAuthorization = () => {
  const authorizationEnvironment = process.env.REACT_APP_AUTHORIZATION_CONFIG;

  switch (authorizationEnvironment) {
    case "MSAL":
      return new AuthorizationMSAL();
    case "ADFS":
      return new AuthorizationADFS();
    default:
      return new AuthorizationBase();
  }
};

export const AuthContext = React.createContext<AuthorizationBase>(
  createAuthorization()
);
